import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

interface IGigaObj {
    id: any;
    name: string;
    type: string;
    location?: any;
}

@Component({
    selector: 'datasource-list',
    templateUrl: './datasource.list.template.html',
    styleUrls: ['./datasource.list.style.scss']
})
export class DatasourceListComponent implements OnInit {
    @Input() type: string;
    @Input() dataSource: IGigaObj[];

    @Output() removeEvent: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit(): void { }


    removeItem(item) {
        this.removeEvent.emit(item);
    }
}
